import React from "react";

interface PackageCategoryWatchdogSubscribedProperties {
    readonly packageCategoryTitle: string;
}

export default function PackageCategoryWatchdogSubscribed({
    packageCategoryTitle,
}: PackageCategoryWatchdogSubscribedProperties): React.JSX.Element {
    return (
        <div className="watchdog-confirm">
            <div className="telephone-bubble">
                <div className="w_b_l">
                    <i className="fa-solid fa-check"></i>
                </div>
                <div className="w_b_r">
                    Píšu si Vás, jakmile se objeví nějaká novinka
                    v kategorii <strong>{packageCategoryTitle}</strong>,<br />
                    dám Vám vědět na zadaný e-mail &#x1F4E7;
                </div>
            </div>
            <img src="/css/image/light_karel.png" className="light-karel" alt="" />
        </div>
    );
}
